import { Agency } from "../../core/models/agency";

export const featureKey = "agencies";

export interface State {
  policyAgencies: Agency[];
}
